import { render, staticRenderFns } from "./BracketsGrid.vue?vue&type=template&id=79a7d28f&lang=html&"
import script from "./BracketsGrid.vue?vue&type=script&lang=js&"
export * from "./BracketsGrid.vue?vue&type=script&lang=js&"
import style0 from "./BracketsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports